var map = {
	"./de/returnBtn.png": "y1Vg",
	"./en/returnBtn.png": "aNZq",
	"./es/returnBtn.png": "zI1L",
	"./fr/returnBtn.png": "IY/i",
	"./ja/returnBtn.png": "FBiX",
	"./ko/returnBtn.png": "nftW",
	"./pt/returnBtn.png": "QP9Z",
	"./ru/returnBtn.png": "FjbH",
	"./tc/returnBtn.png": "d1wO",
	"./th/returnBtn.png": "lsEA"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Pd2x";